import React from 'react';
import { Link } from 'react-router-dom';
import PricingCTA from './PricingCTA';

function About() {
  return (
    <div className="relative bg-black text-white py-12 px-4 overflow-auto" style={{ height: '100vh' }}>
      <div className="max-w-6xl mx-auto relative">
        {/* Hero Section - Centered */}
        <div className="text-center mb-32 space-y-8">
          <h1 className="text-7xl font-light tracking-wider mb-6 bg-gradient-to-r from-white via-gray-200 to-gray-400 inline-block text-transparent bg-clip-text animate-fade-in">
            About Orchestra
          </h1>
          <p className="text-2xl text-gray-300 max-w-3xl mx-auto font-light tracking-wider leading-relaxed">
            On a quest to make San Francisco a smart city          </p>
        </div>

        {/* Ensemble Section - Left aligned with decorative element */}
        <section className="mb-32 transform hover:scale-[1.02] transition-all duration-500 relative">
          <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-blue-400 via-indigo-500 to-purple-500 rounded-full"></div>
          <div className="ml-8">
            <h2 className="text-5xl font-light tracking-wider mb-6 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500 inline-block text-transparent bg-clip-text">
              Ensemble
            </h2>
            <div className="max-w-3xl">
              <p className="text-3xl font-light italic mb-4 bg-gradient-to-r from-blue-300 via-indigo-300 to-purple-300 inline-block text-transparent bg-clip-text transform hover:scale-105 transition-transform duration-300">
                Without sound, there is no music.
              </p>
              <p className="text-xl text-gray-300 leading-relaxed">
                Our proprietary camera network deployed across San Francisco.
              </p>
            </div>
          </div>
        </section>

        {/* Conductor Section - Right aligned with decorative element */}
        <section className="mb-32 transform hover:scale-[1.02] transition-all duration-500 relative text-right">
          <div className="absolute right-0 top-0 w-1 h-full bg-gradient-to-b from-orange-400 via-pink-500 to-rose-500 rounded-full"></div>
          <div className="mr-8">
            <h2 className="text-5xl font-light tracking-wider mb-6 bg-gradient-to-r from-orange-400 via-pink-500 to-rose-500 inline-block text-transparent bg-clip-text">
              Conductor
            </h2>
            <div className="max-w-3xl ml-auto">
              <p className="text-3xl font-light italic mb-4 bg-gradient-to-r from-orange-300 via-pink-300 to-rose-300 inline-block text-transparent bg-clip-text transform hover:scale-105 transition-transform duration-300">
                Without vision, there is no harmony.
              </p>
              <p className="text-xl text-gray-300 leading-relaxed">
                Our computer vision engine transforms raw footage into actionable insights.
              </p>
            </div>
          </div>
        </section>



        {/* Symphonies Section - Centered */}
        <section className="mb-32">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-light tracking-wider mb-8 bg-gradient-to-r from-green-400 via-emerald-500 to-teal-500 inline-block text-transparent bg-clip-text">
              Symphonies
            </h2>
            <div className="max-w-3xl mx-auto">
              <p className="text-3xl font-light italic bg-gradient-to-r from-green-300 via-emerald-300 to-teal-300 inline-block text-transparent bg-clip-text transform hover:scale-105 transition-transform duration-300">
                Now Playing: Movement I
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              { title: 'Archangel', path: '/archangel', desc: 'A unified camera network solving major crimes in San Francisco' },
              { title: 'Veritas', path: '/veritas', desc: 'Video evidence that eliminates fraudulent car crash claims' }
            ].map(({ title, path, desc }) => (
              <Link
                to={path}
                key={title}
                className="group bg-gradient-to-br from-gray-900/50 via-gray-900/30 to-black/50 p-10 rounded-2xl 
                          hover:bg-gradient-to-br hover:from-green-900/20 hover:via-emerald-900/20 hover:to-teal-900/20 
                          transition-all duration-500 transform hover:scale-105 backdrop-blur-sm border border-gray-800/50"
              >
                <h3 className="text-2xl font-light mb-6 group-hover:text-green-300 transition-colors duration-300">{title}</h3>
                <p className="text-gray-400 group-hover:text-gray-300 transition-colors duration-300">
                  {desc}
                </p>
              </Link>
            ))}
          </div>
        </section>

        {/* Add PricingCTA before closing divs */}
        {/* <PricingCTA className="mb-24" /> */}
      </div>
    </div>
  );
}

export default About; 